<template>
  <div v-if="show" class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal">
      <button class="close" @click="$emit('close')">×</button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['show'],
  watch: {
    show(newVal) {
      // Agrega o remueve la clase al body cuando el modal se abre/cierra
      if (newVal) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  },
  beforeUnmount() {
    // Limpieza al destruir el componente
    document.body.classList.remove('no-scroll');
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Estilos para WEB (pantallas grandes) */
.modal {
  position: relative;
  background: #fff;
  width: 90%;
  max-width: 600px;    /* Ancho máximo fijo en web */
  min-height: 150px;   /* Altura mínima reducida */
  max-height: 70vh;    /* Altura máxima ajustada */
  padding: 20px;
  border-radius: 12px;
  z-index: 1000;
  overflow-y: auto;    /* Scroll si el contenido es largo */
}

.close {
  float: right;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

/* Estilos para MÓVIL (pantallas <= 600px) */
@media (max-width: 600px) {
  .modal {
    width: 95%;
    max-width: 95%;    /* Ocupa casi todo el ancho en móvil */
    min-height: 120px; /* Altura mínima aún más reducida */
    max-height: 50vh;  /* Altura máxima un poco mayor para móvil */
    padding: 15px;     /* Padding más ajustado */
  }

  .close {
    font-size: 20px;   /* Botón de cerrar más pequeño */
  }
}

.modal {
  display: block !important;
  opacity: 1 !important;
}
</style>
